// extracted by mini-css-extract-plugin
export var card = "advantages-module--card--WCxz1";
export var container = "advantages-module--container--yYKQl";
export var description = "advantages-module--description--eAkOt";
export var headTitle = "advantages-module--headTitle--W6F0A";
export var icon = "advantages-module--icon--7oH+i";
export var list = "advantages-module--list--QU95t";
export var threeSteps = "advantages-module--threeSteps--dYog7";
export var title = "advantages-module--title--glpft";